import { AfterViewInit, Component, computed, OnDestroy, Signal, viewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PrimeIcons } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { COLLAPSED, NavigationItem, SidebarState } from '../../constants/navigation.constants';
import { NavigationService } from '../../services/navigation.service';
import { ThemeService } from '../../services/theme.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-left-sidebar',
  imports: [ButtonModule, MenuModule, RouterLink, TooltipModule, RouterLinkActive ],
  templateUrl: './left-sidebar.component.html',
})
export class LeftSidebarComponent implements AfterViewInit, OnDestroy {
  items: Signal<NavigationItem[]>;
  transitionDirection: SidebarState;
  isAnimatingNav = false;
  state = '';
  currentPath = '';

  resizeObserver = new ResizeObserver(this.onResize);

  menuEl = viewChild<Menu>('navMenu');

  constructor (
    private theme: ThemeService,
    private user: UserService,
    private nav: NavigationService
  ) {
    const logoutNavItem = {
      label: '',
      items: [
        {
            label: 'Sign Out',
            title: 'Sign Out',
            icon: PrimeIcons.SIGN_OUT,
            // command: () => this.user.logout(true) // popup
            command: () => this.user.logout() // redirect
        }
      ]
    };
    this.items = computed(() => this.nav.navItems().concat(logoutNavItem));
    this.transitionDirection = this.theme.sidebarState;
    this.state = this.transitionDirection === SidebarState.EXPAND ? COLLAPSED : '';
  }

  ngAfterViewInit(): void {
    const scrollable = this.menuEl()?.el.nativeElement.children[0].children[0];
    if (scrollable.classList.contains('p-menu-list')) {
      this.resizeObserver.observe(scrollable)
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect()
  }

  onResize(entries: ResizeObserverEntry[]) {
    entries.forEach(entry => {
      const navMenu = entry.target.parentElement;
      if (navMenu?.parentElement?.classList.contains('collapsed')) {
        if (entry.borderBoxSize[0].inlineSize > entry.contentRect.left + entry.contentRect.right) {
          requestAnimationFrame(() => {
            if (!navMenu.classList.contains('with-scrollbar')) {
              navMenu.classList.add('with-scrollbar')
            }
          })
        } else {
          requestAnimationFrame(() => {
            if (navMenu?.classList.contains('with-scrollbar')) {
              navMenu.classList.remove('with-scrollbar')
            }
          })
        }
      }
    });
  }

  toggleNavWidth(transitionDirection: string, button: Button) {
    if (this.isAnimatingNav) return; // Prevent duplicate actions
    const buttonEl = button.el.nativeElement;
    const arrowIcon = buttonEl.querySelector('.pi');
    this.isAnimatingNav = true;
    const animationCompleteHandler = () => {
      // on transition end set the sidebar state and the toggle text
      this.theme.sidebarState = transitionDirection === SidebarState.COLLAPSE ? SidebarState.EXPAND : SidebarState.COLLAPSE;
      this.transitionDirection = this.theme.sidebarState;
      this.isAnimatingNav = false;
      // remove the listener to prevent multiple events
      arrowIcon.removeEventListener('transitionend', animationCompleteHandler);
    }
    // add the event listener
    arrowIcon.addEventListener('transitionend', animationCompleteHandler);
    // trigger the animations (menu and arrow)
    this.state = transitionDirection === SidebarState.EXPAND ? '' : COLLAPSED;
  }
  
}
